import { render, staticRenderFns } from "./account-select.vue?vue&type=template&id=35b22a20&scoped=true&"
import script from "./account-select.vue?vue&type=script&lang=js&"
export * from "./account-select.vue?vue&type=script&lang=js&"
import style0 from "./account-select.vue?vue&type=style&index=0&id=35b22a20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b22a20",
  null
  
)

export default component.exports